import { GraviButton, MaterialIcon } from '@gravitate-js/excalibrr'
import { useQueryClient } from '@tanstack/react-query'
import { notification } from 'antd'
import { useState } from 'react'
import type { InvoiceGroup } from '../../../../../../api/useFreight/types'
import { useInvoices } from '../../../../../../api/useFreight/useInvoices'

export function ApproveCreditButton({ invoiceGroup }: { invoiceGroup: InvoiceGroup }) {
  const { useApproveRebillMutation } = useInvoices()
  const approveRebillMutation = useApproveRebillMutation()
  const queryClient = useQueryClient()
  const [loading, setLoading] = useState(false)
  const handleApproveCredit = async () => {
    setLoading(true)
    const rebillInvoice = invoiceGroup.invoices.find((invoice) => invoice.type === 'rebill')
    const creditInvoice = invoiceGroup.invoices.find((invoice) => invoice.type === 'credit')
    await approveRebillMutation.mutateAsync({
      invoice_group_id: invoiceGroup.id,
      rebill_invoice_number: rebillInvoice?.invoice_number ?? '',
      credit_invoice_number: creditInvoice?.invoice_number ?? '',
    })
    queryClient.invalidateQueries({ queryKey: ['invoice'] })
    queryClient.invalidateQueries({ queryKey: ['invoices-be-query'] })
    notification.success({
      message: 'Credit/Rebill Approved',
      description: `Credit/Rebill has been approved for ${invoiceGroup?.counterparty_name} (${rebillInvoice?.invoice_number} / ${creditInvoice?.invoice_number}). Invoices being sent now.`,
      placement: 'topRight',
      icon: <MaterialIcon icon='check_circle' style={{ color: 'var(--theme-success)' }} />,
    })
    setLoading(false)
  }

  return (
    <GraviButton
      color='primary'
      buttonText='Approve Credit/Rebill'
      icon={<MaterialIcon icon='check_circle' className='pt-1' />}
      onClick={handleApproveCredit}
      loading={loading}
    />
  )
}
